import React from "react";
import { Icon } from "@iconify/react";

const PaginationHelper = ({
    currentPage,
    totalPages,
    onPageChange,
    totalItems,
    pageSize,
}) => {

    const RANGE = 3;

    const getPages = () => {
        const pages = [];

        const start = Math.max(1, currentPage - RANGE);
        const end = Math.min(totalPages, currentPage + RANGE);

        if (start > 1) {
            pages.push(1);
            if (start > 2) pages.push("left-ellipsis");
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (end < totalPages) {
            if (end < totalPages - 1) pages.push("right-ellipsis");
            pages.push(totalPages);
        }

        return pages;
    };

    const pages = getPages();

    return (
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-12">

            <span className="text-xs">
                Showing {(currentPage - 1) * pageSize + 1} to{" "}
                {Math.min(currentPage * pageSize, totalItems)} of {totalItems} entries
            </span>

            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">

                <li className="page-item">
                    <button
                        disabled={currentPage === 1}
                        onClick={() => onPageChange(currentPage - 1)}
                        className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-28-px w-28-px text-xs p-0"
                    >
                        <Icon icon="ep:d-arrow-left" width={12} />
                    </button>
                </li>

                {pages.map((page, index) => {

                    if (page === "left-ellipsis") {
                        return (
                            <li key={index} className="page-item">
                                <button
                                    onClick={() => onPageChange(Math.max(1, currentPage - RANGE))}
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-28-px w-28-px text-xs"
                                >
                                    ...
                                </button>
                            </li>
                        );
                    }

                    if (page === "right-ellipsis") {
                        return (
                            <li key={index} className="page-item">
                                <button
                                    onClick={() => onPageChange(Math.min(totalPages, currentPage + RANGE))}
                                    className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-28-px w-28-px text-xs"
                                >
                                    ...
                                </button>
                            </li>
                        );
                    }

                    return (
                        <li key={index} className="page-item">
                            <button
                                onClick={() => onPageChange(page)}
                                className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-28-px w-28-px text-xs ${currentPage === page
                                        ? "bg-primary-600 text-white"
                                        : "bg-neutral-200 text-secondary-light"
                                    }`}
                            >
                                {page}
                            </button>
                        </li>
                    );
                })}

                <li className="page-item">
                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => onPageChange(currentPage + 1)}
                        className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-28-px w-28-px text-xs p-0"
                    >
                        <Icon icon="ep:d-arrow-right" width={12} />
                    </button>
                </li>

            </ul>
        </div>
    );
};

export default PaginationHelper;